import styles from './CartDeliveryFreeSlotsBadge.module.scss'

export const CartDeliveryFreeSlotsBadge = () => (
  <div className={styles.badge} />
)
